import { render, staticRenderFns } from "./ServiceSupport.vue?vue&type=template&id=4f99816c&scoped=true"
import script from "./ServiceSupport.vue?vue&type=script&lang=js"
export * from "./ServiceSupport.vue?vue&type=script&lang=js"
import style0 from "./ServiceSupport.vue?vue&type=style&index=0&id=4f99816c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99816c",
  null
  
)

export default component.exports